import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-addon-popup-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './addon-popup-widget.component.html',
  styleUrls: ['./addon-popup-widget.component.scss'],
})
export class AddonPopupWidgetComponent implements OnInit {
  show = false;
  selectedButton: string = '';
  private readonly intervalDays = 2;
  private readonly totalDays = 20;
  private readonly firstShownKey = 'addonPopupFirstShown';
  private readonly lastShownKey = 'addonPopupLastShown';
  constructor(private router: Router) {}

  ngOnInit(): void {
    const now = Date.now();
    const intervalMs = this.intervalDays * 24 * 60 * 60 * 1000;
    const totalMs = this.totalDays * 24 * 60 * 60 * 1000;
    const firstShown = localStorage.getItem(this.firstShownKey);
    const lastShown = localStorage.getItem(this.lastShownKey);
    if (!firstShown || !lastShown) {
      this.showPopup(now);
      return;
    }
    const firstShownTime = parseInt(firstShown, 10);
    if (now - firstShownTime > totalMs) return;
    const lastShownTime = lastShown ? parseInt(lastShown, 10) : 0;
    if (now - lastShownTime >= intervalMs) {
      this.showPopup(now);
    }
  }

  private showPopup(now: number) {
    this.show = true;
    if (!localStorage.getItem(this.firstShownKey)) {
      localStorage.setItem(this.firstShownKey, now.toString());
    }
    localStorage.setItem(this.lastShownKey, now.toString());
  }

  closePopup() {
    this.show = false;
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
    this.closePopup();
  }

  isActive(path: string): boolean {
    return this.selectedButton === path;
  }
}
